import React, { useCallback, useMemo } from 'react';
import { Divider, Modal } from 'antd';
import { CollectionServer, GetMetaProperties, QueryDetail, SetMetaProperties, clean, deleteInArray, deleteInProperties, foreachInProperties, getObjectDisplay, updateInArray, useMetaContext, updateInPropertiesUUID, contextFilterToObject } from 'fennec-ui'
import { POST, errorCatch, ObjectToContextFilters, ContextFiltersToQueryFilters } from 'fennec-ui'
import { ExclamationCircleOutlined } from '@ant-design/icons';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import ObjectOwnerDescription from '../../../fedance-ui/ObjectOwnerDescription';
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');

var _ = require('lodash');

const ShablonRender = (props) => {
    const { item, style } = props;
    return (<div style={style}>
        <div>{item?.nazvanie}</div>
        <div style={{ color: "#6a6a6a" }}><ObjectOwnerDescription object={item} inline={true} /></div>
        {/* <div>{getObjectDisplay(item, "ShabloniSudeiskikhGonorarov", meta)}</div> */}
        {/* <div style={{ color: "#6a6a6a" }}></div> */}
    </div>)
}

export default function GonorarBlock(props) {
    const { auth, source, create, ctx, sourceKey, title, size, event } = props;

    // async function exampleFetch(auth, url) {
    //     console.log("2");
    //     let x = await GETP(auth, url);
    //     console.log("3",x);
    //     return x
    // }
    // console.log("1");
    // console.log(exampleFetch(auth,'/api/meta'));
    // console.log("4");

    const meta = useMetaContext();
    const filtersFromMeta = React.useCallback((name) => {
        let prop = [];
        // let p = _.get(meta[name], "properties");
        let p = GetMetaProperties(meta[name])
        p = deleteInProperties(p, ["CreatedAt", "UpdatedAt", "DeletedAt", "OrganizatorShkola", "OrganizatorMeropriyatiya", "OrganizatorRegionalnoeOtdelenie", "OrganizatorFederatsiya", "Meropriyatie", "ID"])
        if (p) {
            prop = p?.filter(e => !_.get(e, "relation") || _.get(e, "relation.type") !== "one-many")?.map(e => ({ ...e, sort: true, filter: true, func: (e.filterType == "range") ? ["min", "max"] : undefined }))
        }
        return prop;
    }, [meta]);
    const cleanProperties = (obj, context, funcs) => {
        const { name, field, fieldName, contextObject, object } = context;

        if (!obj) { return obj }

        let p = GetMetaProperties(obj)

        p = deleteInProperties(p, ["CreatedAt", "UpdatedAt", "DeletedAt", "OrganizatorShkola", "OrganizatorMeropriyatiya", "OrganizatorRegionalnoeOtdelenie", "OrganizatorFederatsiya", "Meropriyatie"])

        if (object && obj.type == "object") {
            p = updateInPropertiesUUID(p, {
                uuid: "object-owner-description",
                type: "func",
                render: () => (<ObjectOwnerDescription object={object} style={{ marginBottom: "5px" }} />)
            }, true)
        }

        if (contextObject && obj.type == "object" && field) {
            let fName = _.get(field, "relation.reference.property");
            let o = obj?.properties?.find(e => e.name == fName)
            if (o) {
                let oObj = _.get(o, "relation.reference.object");
                let oMeta = meta[oObj];
                p = updateInPropertiesUUID(p, {
                    uuid: "object-context-description",
                    type: "func",
                    render: () => (<div className='bg bg-grey' style={{ textAlign: "left", padding: "5px", marginBottom: "5px" }}>
                        {(oMeta) && <div style={{
                            fontSize: "10px",
                            color: "rgb(106, 106, 106)",
                            lineHeight: "10px",
                            fontStyle: "italic"
                        }}>{o?.label} ({oMeta?.label})</div>}
                        <div>{getObjectDisplay(contextObject, oObj, meta)}</div>
                        <div style={{ color: "#6a6a6a" }}><ObjectOwnerDescription object={contextObject} inline={true} /></div>
                    </div>)
                }, true)
            }
        }

        p = foreachInProperties(p, n => (_.get(n, "relation.reference.object") == "ShabloniSudeiskikhGonorarov"), {
            source: source,
            queryFilter: [...ContextFiltersToQueryFilters(ObjectToContextFilters(ctx)), QueryDetail("collection")]
        })

        p = foreachInProperties(p, n => (object && name == "ShabloniSudeiskikhGonorarov" && n.name == "DetShablonaSudGonorarovShablon"), {
            source: `/api/detshablonasudgonorarov/byshablonpage/${object?.ID}`
        })

        if (funcs) {
            for (let i = 0; i < funcs.length; i++) {
                const f = funcs[i];
                p = f(p);
            }
        }

        return SetMetaProperties(obj, p)
    }
    const mactions = (e, mobject, { name, field, fieldName, contextObject, object: item }) => {
        const { key, action, contextFilters } = e;
        if (name == "ShabloniSudeiskikhGonorarov" && key == "create") {
            return (values, unlock, close, { collection, setCollection }) => {
                let ctxFlt = contextFilterToObject(contextFilters);
                POST(auth, "/api/shablonisudeiskikhgonorarov/new",
                    { ...values, ...ctxFlt, ...((event?.ID) ? { meropriyatieID: event.ID } : {}) },
                    ({ data }) => {
                        setCollection(updateInArray(collection, data))
                        close()
                    }, (err) => errorCatch(err, unlock));
            }
        } else if (name == "ShabloniSudeiskikhGonorarov" && key == "update") {
            return (values, unlock, close, { collection, setCollection }) => {
                let ctxFlt = contextFilterToObject(contextFilters);
                POST(auth, "/api/shablonisudeiskikhgonorarov/update",
                    { ...values, ...ctxFlt, ID: item.ID },
                    ({ data }) => {
                        setCollection(updateInArray(collection, data))
                        close()
                    }, (err) => errorCatch(err, unlock));
            }
        } else if (name == "ShabloniSudeiskikhGonorarov" && key == "delete") {
            return (values, unlock, close, { collection, setCollection }) => {
                Modal.confirm({
                    title: `Вы уверены что хотите удалить элемент?`,
                    icon: <ExclamationCircleOutlined />,
                    content: (<div>
                        {(mobject) && <div style={{ fontSize: "12px", color: "grey" }}>
                            <div>{mobject?.label}</div>
                        </div>}
                        <div>{getObjectDisplay(item, name, meta)}</div>
                    </div>),
                    okText: "Да",
                    okType: 'danger',
                    cancelText: "Нет",
                    onOk: () => {
                        POST(auth, "/api/shablonisudeiskikhgonorarov/delete", item,
                            () => {
                                setCollection(deleteInArray(collection, item))
                            }, errorCatch
                        );
                    },
                });
            }
        } else if (name == "DetShablonaSudGonorarov" && key == "create") {
            return (values, unlock, close, { collection, setCollection }) => {
                let ctxFlt = contextFilterToObject(contextFilters);
                POST(auth, "/api/detshablonasudgonorarov/new",
                    { ...values, ...ctxFlt },
                    ({ data }) => {
                        setCollection(updateInArray(collection, data))
                        close()
                    }, (err) => errorCatch(err, unlock));
            }
        } else if (name == "DetShablonaSudGonorarov" && key == "update") {
            return (values, unlock, close, { collection, setCollection }) => {
                let ctxFlt = contextFilterToObject(contextFilters);
                POST(auth, "/api/detshablonasudgonorarov/update",
                    { ...values, ...ctxFlt, ID: item.ID },
                    ({ data }) => {
                        setCollection(updateInArray(collection, data))
                        close()
                    }, (err) => errorCatch(err, unlock));
            }
        } else if (name == "DetShablonaSudGonorarov" && key == "delete") {
            return (values, unlock, close, { collection, setCollection }) => {
                Modal.confirm({
                    title: `Вы уверены что хотите удалить элемент?`,
                    icon: <ExclamationCircleOutlined />,
                    content: (<div>
                        {(mobject) && <div style={{ fontSize: "12px", color: "grey" }}>
                            <div>{mobject?.label}</div>
                        </div>}
                        <div>{getObjectDisplay(item, name, meta)}</div>
                    </div>),
                    okText: "Да",
                    okType: 'danger',
                    cancelText: "Нет",
                    onOk: () => {
                        POST(auth, "/api/detshablonasudgonorarov/delete", item,
                            () => {
                                setCollection(deleteInArray(collection, item))
                            }, errorCatch
                        );
                    },
                });
            }
        }
        return action
    }

    const x = useCallback(() => ObjectToContextFilters(ctx), [ctx])
    return (<div>
        {title || <Divider type="horizontal" orientation="left">
            Гонорары
        </Divider>}
        <CollectionServer
            auth={auth}
            name={"ShabloniSudeiskikhGonorarov"}
            source={source}
            queryDetail={"model"}
            // queryDetail={"collection"}
            filters={() => filtersFromMeta("ShabloniSudeiskikhGonorarov")}

            contextFilters={x}

            mode="list"
            render={(item, idx) => (
                <div style={{ padding: "0px 5px" }}>
                    <ShablonRender item={item} />
                </div>
            )}

            linksModelActions={"inline"}
            scheme={[
                "DetShablonaSudGonorarovShablon"
            ]}

            modelActions={(item, index, { mobject, name, field, fieldName, contextObject, collection, actions }) => {
                return actions.map(e => ({
                    ...e,
                    action: mactions(e, mobject, { name, field, fieldName, contextObject, object: item }),
                    meta: cleanProperties(mobject, { name, field, fieldName, contextObject, object: item })
                }))
            }}
            collectionActions={({ mobject, name, field, fieldName, contextObject, collection, actions }) => {
                let funcs = []
                let ac = actions.map(e => ({
                    ...e,
                    action: mactions(e, mobject, { name, field, fieldName, contextObject, object: undefined }),
                    meta: cleanProperties(mobject, { name, field, fieldName, contextObject, object: undefined }, funcs)
                }))
                return ac
            }}
        />
    </div>);
}
